export enum PaymentProvider {
  None = "None",
  Stripe = "Stripe",
  Payrix = "Payrix",
  Worldpay = "Worldpay",
  NonIntegrated = "NonIntegrated",
}

export const PaymentProviderList: () => {
  label: string;
  value: string | null;
}[] = () => [
  { label: "None", value: PaymentProvider.None },
  { label: "Stripe", value: PaymentProvider.Stripe },
  { label: "Payrix", value: PaymentProvider.Payrix },
  { label: "Worldpay for Platforms", value: PaymentProvider.Worldpay },
  { label: "Non Integrated", value: PaymentProvider.NonIntegrated },
];

export const getPaymentProviderLabel = (
  value: string | null | undefined
): string => {
  return (
    PaymentProviderList().find((provider) => provider.value === value)?.label ??
    value ??
    "-"
  );
};
